import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { CartAddModal, SampleItemGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function CurrentSampleItems(props) {
   const [addToCart, setAddToCart] = useState(null)
   const [customerId, setCustomerId] = useState(props.customerId)
   const [data, setData] = useState([]);
   const [loaded, setLoaded] = useState(false)

   useEffect(() => {
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId)
         setLoaded(false);
      }
      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId])

   function getSampleItemXLSX() {
      return api
         .postGetBlob("Customer/ExportSampleItemsXLSX", { CustomerId: props.customerId })
         .then((response) => {
            if (response && response.data) {
               const XLSX_FILENAME = `${customerId}_Sample_Items.xlsx`;
               helpers.downloadExport(response.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx);
            }
            else {
               toast.error(response.message || "Error downloading report.");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post(`Customer/GetSampleItems`,
            {
               CustomerId: props.customerId
            })
         .then(response => {
            if (response.data.success) {
               setData(response.data.samples); // List of SampleItemRequestDto.cs
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));
   }

   return (
      <>
         <div>
            <span className="h2">Sample Items</span><span>&nbsp;</span> <span className="text-muted">Customer #{customerId}</span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {data && data.length
               ? <SampleItemGrid
                  data={data}
                  exportXlsxCallback={getSampleItemXLSX}
                  addToCartCallback={setAddToCart}
               />
               : <span className="h5">No Sample Items found</span>
            }
            {
               addToCart
                  ? <CartAddModal
                     item={addToCart}
                     exitCallback={() => setAddToCart(null)}
                  />
                  : null
            }
         </ServiceThreadSpinner>
      </>
   )
}